import styled from 'styled-components'
import { rem } from 'polished'
import LineAngleRightBIcon from 'LuxKit/Icons/line/LineAngleRightBIcon'
import type { SvgIconProps } from 'LuxKit/SvgIcon'

const directions = {
  right: 0,
  down: 90,
  left: 180,
  up: 270,
}

interface Props extends SvgIconProps {
  /**
   * Sets the direction of the arrow
   *
   * @default right
   */
  direction?: 'up' | 'down' | 'left' | 'right'
}

const StyledIcon = styled(LineAngleRightBIcon)`
  transform: rotate(${({ direction }) => direction}deg);
  transition: transform 100ms ease-out;
`

export const CSSArrow = styled.span`
  display: flex;
  align-items: center;
  min-width: ${rem(30)};
  padding-inline: ${rem(5)};

  &::after {
    display: block;
    width: ${rem(6)};
    height: ${rem(6)};
    margin-inline-start: ${rem(-8)};
    content: "";
    border-top: 2px solid currentColor;
    border-inline-end: 2px solid currentColor;
    transform: rotate(45deg);
  }

  /* The logical border already mirrors the corner, so a counter-rotation points it towards inline-end */
  [dir="rtl"] &::after {
    transform: rotate(-45deg);
  }
`

function Arrow(props: Props) {
  const { direction = 'right', ...rest } = props

  return <StyledIcon
    {...rest}
    direction={directions[direction] || 0}
  />
}

export default Arrow
